export const META_PIXEL_ID = '931401796468747'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

/**
 * Loads the Meta (Facebook) Pixel base code, initializes it with the
 * configured pixel id and fires the initial PageView event.
 * Safe to call multiple times — the script is only injected once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    // Already initialized — just track the page view.
    window.fbq('track', 'PageView')
    return
  }

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      // The classic FB snippet assumes an existing <script> tag to insert
      // before. In sandboxed environments there may be none, so fall back to
      // <head> / documentElement instead of crashing on s.parentNode.
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq && window.fbq('init', META_PIXEL_ID)
    window.fbq && window.fbq('track', 'PageView')
  } catch (err) {
    // Never let analytics break the app render.
    console.warn('Meta Pixel failed to initialize:', err)
  }
}

/** Fires a Meta Pixel event (no-op if the pixel hasn't loaded). */
export function trackMetaPixel(
  event: string,
  params?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
